import { render, staticRenderFns } from "./cfgl.vue?vue&type=template&id=85c979a8&scoped=true"
import script from "./cfgl.vue?vue&type=script&lang=js"
export * from "./cfgl.vue?vue&type=script&lang=js"
import style0 from "./cfgl.vue?vue&type=style&index=0&id=85c979a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c979a8",
  null
  
)

export default component.exports